module.exports = __webpack_public_path__ + "img/Сертификат травматология и ортопедия 2019.22712040.jpg";